var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.625 0H9.375C4.19733 0 0 4.19733 0 9.375V30.625C0 35.8027 4.19733 40 9.375 40H30.625C35.8027 40 40 35.8027 40 30.625V9.375C40 4.19733 35.8027 0 30.625 0Z",
    fill: "#F03C2E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_121_125",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 32,
    height: 32
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 4.375H35.625V35.625H4.375V4.375Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_121_125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0351 18.6084L21.3916 4.96477C21.1103 4.68316 20.7517 4.49136 20.3613 4.41367C19.9709 4.33599 19.5663 4.3759 19.1986 4.52836C18.9545 4.62964 18.7328 4.77793 18.5459 4.96477L15.7139 7.7968L19.3076 11.3905C20.1436 11.0976 21.1006 11.2977 21.7666 11.9638C22.0836 12.2814 22.305 12.6818 22.4053 13.1192C22.5056 13.5566 22.4809 14.0134 22.3339 14.4374L25.7978 17.9013C26.6358 17.6123 27.6025 17.7987 28.2714 18.4696C28.6065 18.8045 28.8347 19.2313 28.9271 19.696C29.0194 20.1607 28.9718 20.6423 28.7903 21.0799C28.547 21.6666 28.0806 22.1327 27.4938 22.3757C26.9069 22.6187 26.2476 22.6187 25.6608 22.3757C25.3701 22.2552 25.1061 22.0788 24.8837 21.8563C24.1806 21.1532 24.0069 20.118 24.3623 19.2518L21.1319 16.0213V24.5224C21.3664 24.6384 21.5807 24.7914 21.7666 24.9755C22.2157 25.4247 22.468 26.0338 22.468 26.6689C22.468 27.304 22.2157 27.9132 21.7666 28.3623C21.3174 28.8114 20.7083 29.0637 20.0732 29.0637C19.4381 29.0637 18.8289 28.8114 18.3798 28.3623C18.0447 28.0275 17.8164 27.6008 17.7239 27.1361C17.6314 26.6715 17.6788 26.1899 17.8601 25.7523C17.9806 25.4617 18.1572 25.1977 18.3798 24.9755C18.6112 24.7451 18.8681 24.5702 19.1641 24.453V15.8729C18.8704 15.7529 18.6037 15.5753 18.3798 15.3505C18.0436 15.0147 17.815 14.5863 17.7232 14.12C17.6313 13.6537 17.6804 13.1706 17.8642 12.7323L14.3194 9.18961L4.9639 18.5352C4.68226 18.8167 4.49043 19.1753 4.41269 19.5659C4.33496 19.9564 4.3748 20.3611 4.52718 20.729C4.62852 20.9732 4.77691 21.195 4.9639 21.382L18.6084 35.0245C18.7953 35.2113 19.017 35.3596 19.2611 35.4609C19.7543 35.6648 20.3082 35.6648 20.8014 35.4609C21.0455 35.3596 21.2672 35.2113 21.4541 35.0245L35.0351 21.4649C35.2222 21.2781 35.3705 21.0562 35.4717 20.812C35.573 20.5678 35.6251 20.306 35.6251 20.0416C35.6251 19.7773 35.573 19.5155 35.4718 19.2712C35.3705 19.027 35.2222 18.8051 35.0351 18.6182",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.84bc601a1a94f265c17e5e6ffb186ed6.svg";
export { ForwardRef as ReactComponent };